const Document = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="27"
			height="33"
			viewBox="0 0 27 33"
			fill="none"
		>
			<mask
				id="mask0_709_8738"
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="27"
				height="33"
			>
				<path
					d="M26.0579 0.234375H0.268799V32.4288H26.0579V0.234375Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_709_8738)">
				<path
					d="M20.844 32.4277H5.48382C4.10134 32.4262 2.77588 31.869 1.79822 30.8783C0.820561 29.8875 0.270532 28.5442 0.268799 27.1429L0.268799 5.52027C0.270243 4.11882 0.820145 2.77518 1.79784 1.7842C2.77553 0.793215 4.10115 0.235839 5.48382 0.234375L20.844 0.234375C22.2266 0.236131 23.552 0.793601 24.5297 1.78452C25.5073 2.77544 26.0573 4.11891 26.059 5.52027V27.1429C26.057 28.5441 25.5069 29.8873 24.5293 30.8779C23.5517 31.8686 22.2264 32.4259 20.844 32.4277ZM5.48382 2.68151C4.74129 2.68239 4.02942 2.98175 3.50438 3.51393C2.97934 4.04612 2.68398 4.76766 2.68312 5.52027V27.1429C2.68398 27.8955 2.97934 28.6171 3.50438 29.1492C4.02942 29.6814 4.74129 29.9808 5.48382 29.9817H20.844C21.5865 29.9808 22.2984 29.6814 22.8234 29.1492C23.3485 28.6171 23.6438 27.8955 23.6447 27.1429V5.52027C23.6438 4.76766 23.3485 4.04612 22.8234 3.51393C22.2984 2.98175 21.5865 2.68239 20.844 2.68151H5.48382Z"
					fill="#5D9BFD"
				/>
				<path
					d="M18.7638 8.94759C18.605 8.94847 18.4477 8.91742 18.3008 8.85625C18.154 8.79507 18.0206 8.70497 17.9083 8.59118C17.796 8.47738 17.7071 8.34215 17.6468 8.1933C17.5864 8.04445 17.5558 7.88495 17.5567 7.72402V1.45794C17.5567 1.13343 17.6838 0.822213 17.9102 0.59275C18.1366 0.363286 18.4437 0.234375 18.7638 0.234375C19.084 0.234375 19.391 0.363286 19.6174 0.59275C19.8438 0.822213 19.971 1.13343 19.971 1.45794V6.48054L24.8335 6.40642H24.8476C25.1678 6.40378 25.4759 6.53016 25.7041 6.75775C25.9323 6.98535 26.062 7.29552 26.0646 7.62003C26.0672 7.94454 25.9425 8.25681 25.718 8.48814C25.4935 8.71947 25.1874 8.85091 24.8673 8.85356L18.778 8.94759H18.7638Z"
					fill="#5D9BFD"
				/>
			</g>
		</svg>
	);
};

export default Document;
